export default __webpack_public_path__ + "static/communityone-28687c361252b5d316b1ffa40c0771a9.png";